import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const QUIET_STATUSES = ["active", "covered", "beta"];

export function useBillingStatus() {
  const { user } = useAuth();
  const location = useLocation();
  const [access, setAccess] = useState(null);

  useEffect(() => {
    if (!user) { setAccess(null); return; }
    api.get("/billing/me").then((r) => setAccess(r.data.access)).catch(() => setAccess(null));
  }, [user, location.pathname]);

  if (!access || access.mode === "free" || QUIET_STATUSES.includes(access.status) || location.pathname.startsWith("/billing")) {
    return { access, visible: false, locked: false, urgent: false };
  }
  const locked = !access.can_write;
  const urgent = locked || ["past_due", "covered_grace"].includes(access.status) || (access.status === "trialing" && access.days_left <= 7);
  const hideLink = user?.role === "client" && access.status === "covered_grace";
  return { access, visible: access.status !== "trialing" || urgent, locked, urgent, hideLink };
}
